import {combineReducers} from 'redux';
import websocketReducer from './websocket/reducer';

const reducer = combineReducers({
    websocket: websocketReducer,
});

export default reducer;
